import React from "react";
import NavbarComponent from '../component/NavbarComponent'

const OutdoorGames = () => {
  return (
    <React.Fragment>
    <NavbarComponent />

      <div className="relative  min-h-screen">
        <div className="lg:grid lg:grid-cols-5 gap-10 lg:p-20 p-10 opacity-90">
          <div className="shadow-lg text-white text-lg  text-center p-5 rounded-lg mt-2 bg-blue-900  hover:border-2 hover:border-white hover:outline hover:outline-offset-4 hover:outline-2 ">
            <div className="font-bold">
              <span></span>
            </div>
            <div className="font-bold">
              <span className="text-2xl">Football</span>
            </div>
          </div>
          <div className="shadow-lg text-white text-lg  text-center p-5 rounded-lg mt-2 bg-blue-900  hover:border-2 hover:border-white hover:outline hover:outline-offset-4 hover:outline-2">
            <div className="font-bold">
              <span></span>
            </div>
            <div className="font-bold">
              <span className="text-2xl">Kho-Kho</span>
            </div>
          </div>
          <div className="shadow-lg text-white text-lg  text-center p-5 rounded-lg mt-2 bg-blue-900  hover:border-2 hover:border-white hover:outline hover:outline-offset-4 hover:outline-2">
            <div className="font-bold">
              <span></span>
            </div>
            <div className="font-bold">
              <span className="text-2xl">Kabbadi</span>
            </div>
          </div>
          <div className="shadow-lg text-white text-lg  text-center p-5 rounded-lg mt-2 bg-blue-900  hover:border-2 hover:border-white hover:outline hover:outline-offset-4 hover:outline-2">
            <div className="font-bold">
              <span></span>
            </div>
            <div className="font-bold">
              <span className="text-2xl">Cricket</span>
            </div>
          </div>
          <div className="shadow-lg text-white text-lg  text-center p-5 rounded-lg mt-2 bg-blue-900  hover:border-2 hover:border-white hover:outline hover:outline-offset-4 hover:outline-2">
            <div className="font-bold">
              <span></span>
            </div>
            <div className="font-bold">
              <span className="text-2xl">VollyBall</span>
            </div>
          </div>
        </div>
      </div>

      <footer className="border-t-2">
        <div className="text-center font-bold p-6 bg-white">
          <span className="text-black">© 2022 - </span>
          <span className="text-black text-lg font-bold hover:text-blue-300 ">
            BISSS-8B
          </span>
          <span className="text-black">
            , Education Department, Bokaro Steel Plant
          </span>
        </div>
      </footer>
    </React.Fragment>
  );
};

export default OutdoorGames;
